import { render, staticRenderFns } from "./MalzemeIslem.vue?vue&type=template&id=13e8561d&scoped=true&"
import script from "./MalzemeIslem.vue?vue&type=script&lang=js&"
export * from "./MalzemeIslem.vue?vue&type=script&lang=js&"
import style0 from "./MalzemeIslem.vue?vue&type=style&index=0&id=13e8561d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e8561d",
  null
  
)

export default component.exports